import posthog from 'posthog-js';
import { isStaleChunkMessage } from '@/lib/chunkError';

const key = import.meta.env.VITE_POSTHOG_KEY as string;
const host = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.i.posthog.com';

if (key) {
  posthog.init(key, {
    api_host: host,
    capture_pageview: false,
    defaults: '2025-05-24',
    before_capture(eventName, eventProperties) {
      if (
        eventName === '$exception' &&
        Array.isArray(eventProperties.$exception_list)
      ) {
        // Suppress stale-chunk errors. After a new Vite deploy, users with a
        // cached index.html request old chunk URLs that no longer exist. The
        // browser returns an HTML 404 and throws a MIME-type TypeError (Safari)
        // or a "Failed to fetch dynamically imported module" error (Chrome/FF).
        // AppErrorBoundary already handles recovery via a hard reload; these are
        // not bugs to investigate.
        if (eventProperties.$exception_list.some(
          (exc: { value?: string }) => isStaleChunkMessage(exc.value ?? '')
        )) {
          return false;
        }

        // Suppress synthetic "Script error." events with no stack frames.
        // These originate from cross-origin scripts (e.g. Wistia, ManyChat
        // widgets) where the browser withholds error details per the same-origin
        // policy. Not actionable from this codebase.
        const isSyntheticScriptError = eventProperties.$exception_list.every(
          (exc: { value?: string; mechanism?: { synthetic?: boolean }; stacktrace?: { frames?: unknown[] } }) =>
            exc.value === 'Script error.' &&
            exc.mechanism?.synthetic === true &&
            (!exc.stacktrace?.frames || exc.stacktrace.frames.length === 0)
        );
        if (isSyntheticScriptError) {
          return false;
        }
      }
      return true;
    },
  });
}

export default posthog;
